import apiClient from './apiClient'
import type { GetCurrentUserResponse } from '@/types/api'

/**
 * GET /api/current-user
 * Get the currently authenticated user's identity, roles, and preferences.
 * This is the first API call the SPA makes on load.
 */
export async function fetchCurrentUser(): Promise<GetCurrentUserResponse> {
  const { data } = await apiClient.get<GetCurrentUserResponse>('/current-user')
  return data
}

/**
 * PUT /api/current-user/language-preference
 * Persist the user's preferred content language so it follows them to new browsers/sessions.
 */
export async function updateLanguagePreference(languageCode: string): Promise<void> {
  await apiClient.put('/current-user/language-preference', { languageCode })
}
